import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-401dd3a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "errors" }
const _hoisted_2 = { key: 0 }

import { withDefaults, computed, watch } from 'vue'

import { useKeyboardStore } from '@/store/keyboard'
import { useKeyboardInputStore } from '@/store/keyboardInput'

import { VTextField } from 'vuetify/components'

interface Props {
  id?: string
  name?: string
  type?: string
  modelValue: string
  placeholder?: string
  errorMessages?: string | string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppInput',
  props: {
    id: null,
    name: { default: '' },
    type: { default: 'text' },
    modelValue: { default: '' },
    placeholder: { default: '' },
    errorMessages: { default: '' }
  },
  emits: ['update:modelValue', 'enter'],
  setup(__props: any, { emit }) {

const props = __props as { id?: string, name: string, type: string, modelValue: string, placeholder: string, errorMessages: string | string[] }

/**
 * AppInput.
 *
 * VuetifyのコンポーネントをラップしたInputコンポーネント.
 */





const value = computed({
  get: () => props.modelValue,
  set: (value: string) => {
    emit('update:modelValue', value)
  },
})

const keyboardInputStore = useKeyboardInputStore()

const onInputChange = (event: Event) => {
  const target = event.currentTarget

  if (!(target instanceof HTMLInputElement)) return

  emit('update:modelValue', target.value)
  keyboardInputStore.setInput(target.value)
}

const onEnter = (e: { keyCode: number }) => {
  if (keyboardStore.getShow) return
  if (e.keyCode === 229) return // 文字変換
  emit('enter')
}

const onInputFocus = () => {
  if (props.id) {
    keyboardInputStore.setInputId(props.id)
    keyboardInputStore.setInput(value.value)
  }
}

// ソフトキーボードフォーカス設定
const keyboardStore = useKeyboardStore()
const readonly = computed(() => {
  if (!keyboardStore.getShow) return false
  return true
})

// ストアで保持する入力値が変更された時、実際の要素に反映
watch(
  () => keyboardInputStore.getInput,
  (newInput: string) => {
    if (props.id && keyboardInputStore.getInputId === props.id) {
      value.value = newInput
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VTextField), {
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      hideDetails: "",
      id: __props.id,
      name: __props.name,
      type: __props.type,
      placeholder: __props.placeholder,
      readonly: _unref(readonly),
      class: _normalizeClass(["input", {
      error: __props.errorMessages && __props.errorMessages.length > 0,
    }]),
      onChange: onInputChange,
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onEnter($event)), ["enter"])),
      onFocus: onInputFocus,
      onClick: onInputFocus
    }, null, 8, ["modelValue", "id", "name", "type", "placeholder", "readonly", "class"]),
    _createElementVNode("div", _hoisted_1, [
      (typeof __props.errorMessages === 'string')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.errorMessages), 1))
        : (Array.isArray(__props.errorMessages))
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.errorMessages, (message, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(message), 1))
            }), 128))
          : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})